import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { clearPayGroupDetails, deleteMultiplePayGroups, deletePayGroup, getPayGroups, selectPayGroup, togglePayGroupEmployeeAssignment } from "store/entities/payroll/payrollSetup/action";
import Table from "components/__new/common/Table";
import SearchBox from "components/__new/common/SearchBox";
import Filter from "components/__new/common/Filter";
import SortBy from "components/__new/common/SortBy";
import useUrlNavigation from "hooks/useUrlNavigation";
import processParams from "utils/processParams";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import DateFormat from "utils/dateFormat";
import { getAllEmployees } from "store/entities/employees/action";
import BulkActionHandler from "components/__new/common/BulkActionHandler";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import { TableContent } from "components/__new/common/TableContent";
import { ReactComponent as IconDotH } from "assets/images/icons/project-icons/dots-v.svg";
import DialogBox from "utils/dialogBox";
import usePayrollEssentials from "hooks/usePayrollEssentials";
import Spinner from "components/__new/common/Spinner";
import PayGroupEmployeeAssignmentModal from "components/__new/grossPayroll/pay-groups/PayGroupEmployeeAssignmentModal";
import useLoginInfo from "hooks/useLoginInfo";
import logger from "utils/logger";

    const PayGroups = () => {
    const {urlQuery} = useUrlNavigation();
    const {dispatch, useSelector, AssignmentLabel, history, EmptyDataUI, truncator} = usePayrollEssentials()
    const location = useLocation();

    const [listParams, setListParams] = useState({ "page": 1, "limit": 10 });
    const {urlQueryParams} = useUrlQueryParams();

    const {getPayGroupData: data, getPayGroupLoading: loading, deletePayGroupResponse, selectedPayGroup} = useSelector(state => state.entities.payrollSetup)
    const [batch, setBatch] = useState([]);
    const {userInfo} = useLoginInfo();

    const allPayGroupIDs = data?.data?.filter(item => item?.employee_ids?.length < 1)?.map(item => item.id) || []

    const [sortOptions, setSortOptions] = useState([
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-up" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=asc"),
            data: {sort: 'createdAt', order: 'asc'},
            active: false,
        },
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-down" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=desc"),
            data: {sort: 'createdAt', order: 'desc'},
            active: false,
        },
    ]);

        const fetchPayGroupItems = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 10, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "searchQuery");
        params = processParams(urlQueryParams, params, "sort", "string", "", "sortBy");
        params = processParams(urlQueryParams, params, "order", "string", "", "sortOrder");

        const sortValue = urlQueryParams["sort"];
        const orderValue = urlQueryParams["order"];
        if (sortValue && orderValue) {
            const newSortOptions = sortOptions?.map((sortOption) => {
                if (sortOption?.data?.sort === sortValue && sortOption?.data?.order === orderValue) {
                    return {...sortOption, active: true};
                }
                else {
                    return {...sortOption, active: false};
                }
            })
            setSortOptions(newSortOptions);
        }

        setListParams(params);
        dispatch(getPayGroups(params));
    }

    const toggleSingleItem = (id) => {
        const alreadyExists = batch?.indexOf(id) > -1
        if (alreadyExists) {
            const filtered = batch?.filter(item => item !== id)
            setBatch(filtered)
        } else {
            setBatch([...batch, id])
        }
    }

    const toggleEntireList = () => {
        if (batch.length !== allPayGroupIDs?.length) {
            setBatch(allPayGroupIDs)
        } else {
            setBatch([])
        }
    }

    const handleDelete = async (item) => {
        const result = await DialogBox({
			title: "Delete Pay Group 😰",
			content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{truncator(item.name)}</span>? This action cannot be undone.</div>,
			buttonYes: "Delete",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            dispatch(deletePayGroup(item.id));
        }
    }

    const handleBulkDelete = async () => {
            const result = await DialogBox({
                title: "Delete Pay Group 😰",
                content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{batch?.length} pay groups</span>? This action cannot be undone.</div>,
                buttonYes: "Delete",
                buttonYesClass: "btn-ep-red",
                buttonNo: "Cancel",
            });
            if (result) {
            dispatch(deleteMultiplePayGroups({ids: batch})).then(() => setBatch([]));
        }
    }

const createPayGroup = () => {
    logger("Employer-Payroll-setup-paygroups-create-attempt", userInfo);
    history.push("/payroll-configuration/pay-groups/create");
}

    useEffect(() => {
        fetchPayGroupItems()
        // eslint-disable-next-line
    }, [location])

    useEffect(() => {
        dispatch(clearPayGroupDetails())
        dispatch(getAllEmployees({page: 1}))
        // eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        if(deletePayGroupResponse?.id !== undefined || deletePayGroupResponse?.count !== undefined) {
            if(urlQueryParams?.status?.length > 0) {
                history.push("/payroll-configuration/pay-groups");
            } else {
                fetchPayGroupItems();
            }
        }
        // eslint-disable-next-line
    }, [deletePayGroupResponse])

    return (
            <div>
                
            <PayGroupEmployeeAssignmentModal
                isQuickAssign
                selectedPayGroup={selectedPayGroup}
                toggleModal={() => dispatch(togglePayGroupEmployeeAssignment())}
            />

            {loading === true && <Spinner message="Fetching Pay Groups" />}

            {urlQueryParams?.search === undefined && loading === false && data?.data && data?.data?.length === 0 &&
                <EmptyDataUI
                    subheader="Create a pay group that fits your organization"
                    onBtnClick={createPayGroup}
                    btnText="+ Create Pay Group" />
            }

            {loading === false && (urlQueryParams?.search !== undefined || !data?.data || data?.data?.length > 0) &&
                <>
                    <div className="payroll-setup-main-page-action">
                            <button disabled={loading} onClick={createPayGroup} className="btn btn-md btn-ep-primary">
                                + Create Pay Group
                            </button>
                    </div>

                    <div className="mt-6 box">

                        <div className={`pl-4 xl:flex flex-wrap ${batch?.length > 1 ? "justify-start" : "justify-between"}`}>
                            <div className="flex-grow flex items-center">
                                <div className="flex">
                                    <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header" onChange={toggleEntireList}
                                        checked={allPayGroupIDs?.length > 0 && batch.length === allPayGroupIDs?.length}
                                    />
                                </div>
                                <div className="w-10 flex justify-center items-center">
                                    <IconDotH className="h-6 svg-fill-ccc" />
                                </div>
                                <Maybe condition={batch?.length > 1}>
                                    <div className="flex items-center">
                                        <BulkActionHandler
                                            count={batch?.length}
                                            onCancel={() => setBatch([])}
                                            onDelete={handleBulkDelete}
                                        />
                                    </div>
                                </Maybe>
                                <Maybe condition={batch?.length < 2}>
                                    <div className="w-full max-w-sm sm:mr-6">
                                        <SearchBox placeholder="Search for pay groups" name="search" extraUrlParams="page=1" />
                                    </div>
                                </Maybe>
                            </div>
                            <Maybe condition={batch?.length === 0}>
                                <div className="mt-2 xl:mt-0 flex flex-wrap space-x-3 sm:space-x-6">

                                        <div>
                                            <Filter filters={[
                                                {
                                                title: "Status",
                                                name: "status",
                                                dataType: "select",
                                                options: [
                                                    {
                                                        display: "All",
                                                        payload: "",
                                                    },
                                                    {
                                                        display: "Assigned",
                                                        payload: "assigned",
                                                    },
                                                    {
                                                        display: "Unassigned",
                                                        payload: "unassigned",
                                                    },
                                                ],
                                            },
                                            ]}/>
                                        </div>
                                    <div>
                                        <SortBy options={sortOptions} title="Sort Order: " firstOption='Select' />
                                    </div>

                                </div>
                            </Maybe>
                        </div>

                        <div className="mt-6">
                            <div>

                                <Table>
                                    <Table.Head>
                                        <th></th>
                                        <th>Name of Pay group</th>
                                        <th></th>
                                        <th>Date Created</th>
                                        <th>No. of Employees</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </Table.Head>
                                    <Table.Body>

                                        <TableContent
                                            loading={loading}
                                            loadingText="Fetching Pay Groups"
                                            data={data?.data}
                                            total={data?.data?.length}
                                            colspan={24}
                                        />

                                        {loading === false && data?.data?.map((item) => {

                                            return (
                                                <tr key={item.id}>
                                                    <td style={{ width: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-checkbox w-5 h-5 multi-select"
                                                            onChange={() =>  {
                                                                if(item?.employee_ids?.length > 0) toast.error(`Cannot select an assigned Pay Group`)
                                                                else {
                                                                    toggleSingleItem(item.id)
                                                                }
                                                            }}
                                                            checked={batch?.includes(item.id)}
                                                            value={item.id}
                                                        />
                                                    </td>
                                                    <td>
                                                        <div className="capitalize">
                                                            {item.name.toLowerCase()}
                                                        </div>
                                                    </td>
                                                    <td></td>
                                                    <td>
                                                        <div className="lt-gray">
                                                            {DateFormat(item.createdAt)}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p className="mb-0 lt-gray">
                                                            {item?.employee_ids?.length}
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <AssignmentLabel isAssigned={item?.employee_ids?.length > 0} />
                                                    </td>
                                                    <td>
                                                    <div className="flex items-center">
                                                        <Maybe condition={item?.status === 'unassigned'}>
                                                            <button onClick={() => {
                                                                dispatch(selectPayGroup(item));
                                                                dispatch(togglePayGroupEmployeeAssignment());
                                                            }} className="text-ep-primary-500 mr-3">Assign</button>
                                                        </Maybe>
                                                        
                                                        <button onClick={() => {
                                                            dispatch(selectPayGroup(item));
                                                            history.push({ pathname: `/payroll-configuration/pay-groups/${item.id}/view`, state: { payload: item }})
                                                        }} className="text-ep-primary-500 mr-3">View</button>

                                                        <button onClick={() => {
                                                            if(item.employee_ids.length > 0) {
                                                                toast.error(`Unable to delete ${item.name.toUpperCase()} as it's currently assigned.`)
                                                            } else {
                                                                handleDelete(item);
                                                            }
                                                        }} className="text-ep-danger">Delete</button>
                                                    </div>
                                                    </td>
                                                </tr>
                                            )}
                                        )}

                                    </Table.Body>
                                </Table>

                                <Maybe condition={!loading && data?.data?.length > 0}>
                                    <div className="mt-6">
                                        <Pagination data={data?.pageInfo} />
                                    </div>
                                </Maybe>

                            </div>
                        </div>
                    </div>
                </>
            }
            </div>
        )
}


export default PayGroups;